import { useState } from 'react'

import { Box, Icon, Tag, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { getFeatureParams } from 'modules/shift_management/lib/getFeatureParams'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  title: string
  description?: string
  button?: React.ReactNode
  upgradeFeature?: Features.shift_management_save_shift_toggle
}

const ActionBox = ({ title, description, button, upgradeFeature }: Props) => {
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)
  const { company } = useCurrentSession()
  const currentSubscription = company.subscription
  const requestReason = currentSubscription.isLegacy
    ? ValidReasons.MissingFeatureLegacy
    : ValidReasons.MissingFeature

  const featureParams = upgradeFeature
    ? getFeatureParams({ feature: upgradeFeature })
    : { from: 'shift_management_action_box' }
  const { from } = featureParams

  return (
    <>
      <Box
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        borderRadius={{ all: 'abs016' }}
        width="full"
        alignItems="center"
        justifyContent="center"
        gap="s24"
        padding="s24"
      >
        <Box alignItems="center" gap="s12" textAlign="center">
          <Icon.Medium icon="shift-management" color="grey700" />
          <Text.Normal size="400" weight="semibold" color="grey1000">
            {title}
          </Text.Normal>
          {description}
        </Box>
        {button ||
          (upgradeFeature && (
            <Box onClick={() => setIsUpgradeModalOpen(true)}>
              <Tag type="grey3" leftItem="icon" icon="lock-locked" iconColor="tangerine1000">
                {i18n.t('custom_reports.dashboards.upsell_modal.upgrade_button')}
              </Tag>
            </Box>
          ))}
      </Box>

      {isUpgradeModalOpen && upgradeFeature && (
        <RequestUpgradeModal
          moduleRequested={AvailableModules.shift_management}
          featureRequested={upgradeFeature}
          requestSource={from}
          requestReason={requestReason}
          onClose={() => setIsUpgradeModalOpen(false)}
        />
      )}
    </>
  )
}

export default observer(ActionBox)
